import React, { useEffect, useState } from 'react';
import GuardState from './GuardState';
import { useAuthentication } from '../../hooks/useAuthentication';
import { useIdentity } from '../../hooks/useIdentity';
import { ComponentKind, ComponentRender } from '../../ui/Component';

const AuthGuard = props => {
  const {
    children,
    role,
    fallback: Fallback
  } = props;
  const authentication = useAuthentication();
  const currentUser = useIdentity();
  const logged = currentUser !== undefined;
  const [guardValid, setGuard] = useState(GuardState.UNKNOWN);
  useEffect(() => {
    if (!logged || !currentUser) {
      setGuard(GuardState.NO_LOGIN);
    } else if (!role || currentUser.suitableFor(role)) {
      setGuard(GuardState.ALLOWED);
    } else {
      setGuard(GuardState.REJECTED);
    }
  }, [setGuard, logged, currentUser]);
  useEffect(() => {
    if (guardValid === GuardState.NO_LOGIN) {
      authentication.login();
    }
  }, [guardValid]);

  if (guardValid === GuardState.ALLOWED) {
    return React.createElement(React.Fragment, null, children);
  }

  if (guardValid === GuardState.REJECTED) {
    return React.createElement(ComponentRender, {
      kind: ComponentKind.ACCESS_DENIED
    });
  }

  return React.createElement(Fallback, null);
};

export default AuthGuard;